module.exports = __webpack_public_path__ + "static/media/ranking de grupos aseguradores.a593a74e.svg";